import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import {
  deleteCuentaDeBanco, getCuentasDeBanco, patchCuentaDeBanco, postCuentaDeBanco,
} from 'api/configuracion/cuentasDeBancos';
import {
  getMetodosDePago,
  getTiposDeCuentasBancarias,
} from 'api/configuracion';
import { getBancos } from 'api/configuracion/bancos';
import { noSpaces } from 'utils/normalizers';

// eslint-disable-next-line react/prop-types
const CuentasBancarias = ({ permission }) => (
  <PlainCRUD
    title="Cuenta Bancaria"
    permission={permission}
    get={getCuentasDeBanco}
    post={postCuentaDeBanco}
    patch={patchCuentaDeBanco}
    delete={deleteCuentaDeBanco}
    fields={[
      {
        name: 'metodo_de_pago',
        label: 'Método de pago',
        type: 'select',
        render: (item) => item?.concepto,
        required: true,
        useCatalog: true,
        labelProp: 'concepto',
        colWidth: 300,
      },
      {
        name: 'numero_de_cuenta',
        label: 'Número de cuenta',
        required: true,
        colWidth: 300,
      },
      {
        name: 'clabe_interbancaria',
        label: 'Clabe Interbancaria',
        normalize: noSpaces,
      },
      {
        name: 'tipo_de_cuenta_bancaria',
        label: 'Tipo de cuenta bancaria',
        render: (item) => item?.descripcion,
        type: 'select',
        required: true,
        useCatalog: true,
      },
      {
        name: 'banco',
        label: 'Banco',
        render: (item) => item?.nombre,
        labelProp: 'nombre',
        useCatalog: true,
        type: 'select',
        required: true,
        colWidth: 220,
      },
      {
        name: 'sucursal',
        label: 'Sucursal',
      },
      {
        name: 'finalidad',
        label: 'Finalidad',
      },
      {
        name: 'cuenta_contable',
        label: 'Cuenta Contable',
        normalize: noSpaces,
      },

      defaultFields.observaciones,
    ]}
    catalogs={[
      {
        permission: 'catalogodemetododepago',
        get: getMetodosDePago,
        formItemName: 'metodo_de_pago',
      },
      {
        permission: 'tipodecuentabancaria',
        get: getTiposDeCuentasBancarias,
        formItemName: 'tipo_de_cuenta_bancaria',
      },
      {
        permission: 'banco',
        get: getBancos,
        formItemName: 'banco',
      },
    ]}
  />
);

export default CuentasBancarias;
